import _ from 'lodash';
import moment from 'moment';
import {
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile
} from '../../Common/network-call';
import {
  INSTANCE_URL,
  FILES_URL,
  LOCAL_TO_GMT_TIME
} from '../../Common/constant';

export const FETCH_USERS = 'FETCH_USERS';
export const OPEN_CHAT = 'OPEN_CHAT';
export const FETCH_CHAT_THREAD = 'FETCH_CHAT_THREAD';
export const FETCH_CHATS = 'FETCH_CHATS';
export const VIEW_USER_MODAL = 'VIEW_USER_MODAL';
export const ATTENDEE_LIST_MODAL = 'ATTENDEE_LIST_MODAL';
export const MEETING_MODAL = 'MEETING_MODAL';
export const TIMEOUT_LIST = 'TIMEOUT_LIST';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';
export const FETCH_SUGGESTED_USERS = 'FETCH_SUGGESTED_USERS';
export const OPEN_SUGGESTED_FILTER = 'OPEN_SUGGESTED_FILTER';

export const fetchUsers = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/networkusers`;
  var body = {
    appuserid: session.userid,
    eventid: session.eventid,
    section: 'chatthreads'
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('chat thread users: ', response);
        dispatch({
          type: FETCH_USERS,
          payload: {
            data: response.users,
            totalUnread: response.totalUnread
          }
        });
        callback({
          success: 1,
          data: response.users,
          totalUnread: response.totalUnread
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };

  // var url = `${INSTANCE_URL}/api/v2/koachifyscript/fetchuserswithchatthread`;
  // var body = { appuserid: session.userid, eventid: session.eventid };

  // return dispatch => {
  //   postRequest(
  //     url,
  //     body,
  //     session,
  //     dispatch,
  //     response => {
  //       console.log('currents response :- ', response);
  //       _.map(response.resource, item => {
  //         if (item.chatthread.length > 0) {
  //           item.chatthreadupdatedon = item.chatthread[0].updateon;
  //         } else {
  //           item.chatthreadupdatedon = null;
  //         }
  //       });

  //       const sortedData = _.orderBy(
  //         response.resource,
  //         ['chatthreadupdatedon'],
  //         ['desc']
  //       );
  //       // console.log('sortedData: ', sortedData);

  //       dispatch({
  //         type: FETCH_USERS,
  //         payload: { data: sortedData, count: sortedData.length }
  //         // payload: { data: response.resource, count: response.resource.count }
  //       });
  //       callback({ success: 1 });
  //     },
  //     error => {
  //       // callback({success: 0, message: error});
  //     }
  //   );
  // };
};

export const searchUsers = (
  session,
  search = '',
  suggestedSearch = false,
  callback
) => {
  var url = `${INSTANCE_URL}/api/v2/networkusers`;
  var body = {
    appuserid: session.userid,
    eventid: session.eventid,
    search: search,
    section: 'chatthreads'
  };

  if (suggestedSearch) {
    body = {
      appuserid: session.userid,
      eventid: session.eventid,
      term: search,
      section: 'filter_by_search'
    };
  }

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('chat threads response :- ', response);
        if (suggestedSearch) {
          // ----- clear reducer
          dispatch({
            type: FETCH_SUGGESTED_USERS,
            payload: {}
          });

          // ----- value set
          let dispatchObj = {
            data: response.users,
            totalUnread: response.totalUnread
          };

          // ----- reducer value set
          dispatch({
            type: FETCH_SUGGESTED_USERS,
            payload: dispatchObj
          });

          // ----- response callback
          callback({
            ...dispatchObj,
            success: 1
          });
        } else {
          dispatch({
            type: FETCH_USERS,
            payload: { data: response.users, totalUnread: response.totalUnread }
          });
          callback({
            success: 1,
            data: response.users,
            totalUnread: response.totalUnread
          });
        }
      },
      error => {
        // callback({success: 0, message: error});
      }
    );
  };

  // var url = `${INSTANCE_URL}/api/v2/koachifyscript/fetchuserswithchatthread`;
  // var body = {
  //   appuserid: session.userid,
  //   eventid: session.eventid,
  //   search: search
  // };

  // return dispatch => {
  //   postRequest(
  //     url,
  //     body,
  //     session,
  //     dispatch,
  //     response => {
  //       // console.log('response :- ', response);
  //       _.map(response.resource, item => {
  //         if (item.chatthread.length > 0) {
  //           item.chatthreadupdatedon = item.chatthread[0].updateon;
  //         } else {
  //           item.chatthreadupdatedon = null;
  //         }
  //       });

  //       const sortedData = _.orderBy(
  //         response.resource,
  //         ['chatthreadupdatedon'],
  //         ['desc']
  //       );
  //       // console.log('sortedData: ', sortedData);

  //       dispatch({
  //         type: FETCH_USERS,
  //         payload: { data: sortedData, count: sortedData.length }
  //         // payload: { data: response.resource, count: response.resource.count }
  //       });
  //       callback({ success: 1 });
  //     },
  //     error => {
  //       // callback({success: 0, message: error});
  //     }
  //   );
  // };
};

export function reorderChatUsers(existingArr = [], top, others = {}) {
  // console.log('existingArr :- ', existingArr);
  // console.log('top :- ', top);
  var totalUnread = 0;
  _.map(existingArr, obj => {
    totalUnread = parseInt(totalUnread) + parseInt(obj.chatthread[0].unread);

    if (obj.chatthread[0].chatthreadid == top) {
      var today = new Date();
      var str = today.toGMTString();
      var datetimeGMT = moment(str, 'ddd, DD MMM YYYY HH:mm:ss'); // Parse string in local time
      var datetime = datetimeGMT.format('YYYY-MM-DD HH:mm:ss');
      // var datetime = LOCAL_TO_GMT_TIME;
      // console.log('datetime :- ', datetime);

      obj.chatthread[0].sendon = datetime;
      obj.chatthread[0].lastsendon = datetime;
      obj.chatthread[0].chattype = others.chattype;
      obj.chatthread[0].message = others.message;
    }
  });

  existingArr.sort(function compare(a, b) {
    var dateA = new Date(a.chatthread[0].lastsendon);
    var dateB = new Date(b.chatthread[0].lastsendon);
    return dateB - dateA;
  });

  // console.log('existingArr after:- ', existingArr);

  return dispatch => {
    dispatch({
      type: FETCH_USERS,
      payload: { data: existingArr, totalUnread: totalUnread }
    });
  };
}

export function clearUsers() {
  return dispatch => {
    dispatch({ type: FETCH_USERS, payload: {} });
  };
}

export function openChat(value) {
  return dispatch => {
    dispatch({ type: OPEN_CHAT, payload: value });
  };
}

export function fetchChatThread(session, targetid, callback) {
  var filter = encodeURI(
    `((eventid=${session.eventid})AND(senderid=${session.userid})AND(receiverid=${targetid}))OR((eventid=${session.eventid})AND(senderid=${targetid})AND(receiverid=${session.userid}))`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chatthread?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_CHAT_THREAD,
          payload: { data: data.resource, count: data.resource.length }
        });
        callback({
          success: 1,
          data: data.resource,
          count: data.resource.length
        });
      },
      error => {}
    );
  };
}

export function clearChatThread() {
  return dispatch => {
    dispatch({ type: FETCH_CHAT_THREAD, payload: {} });
  };
}

export function fetchChats(session, chatthreadid, callback) {
  var filter = encodeURI(
    `(chatthreadid=${chatthreadid})AND(eventid=${session.eventid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chat?filter=(${filter})&order=sendon%20ASC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        let arr = [];
        if (data.resource.length > 0) {
          _.map(data.resource, chat => {
            // if (
            //   // (chat?.senderid == session.userid ||
            //   //   chat?.receiverid == session.userid) &&
            //   !chat?.senderdeleted &&
            //   !chat?.receiverdeleted
            // ) {
            //   arr.push(chat);
            // } else if (
            //   chat?.senderid == session.userid &&
            //   chat?.senderdeleted &&
            //   !chat?.receiverdeleted
            // ) {
            //   arr.push(chat);
            // } else if (
            //   chat?.receiverid == session.userid &&
            //   chat?.receiverdeleted &&
            //   !chat?.senderdeleted
            // ) {
            //   arr.push(chat);
            // } else {
            //   // arr.push(chat);
            // }
            if (chat?.senderid == session.userid) {
              arr.push(chat);
            } else if (chat?.receiverid == session.userid) {
              if (!chat?.senderdeleted && !chat?.receiverdeleted)
                arr.push(chat);
            }
          });
        }
        // dispatch({
        //   type: FETCH_CHATS,
        //   payload: { data: data.resource, count: data.resource.length }
        // });
        dispatch({
          type: FETCH_CHATS,
          payload: { data: arr, count: arr.length }
        });
        callback({ success: 1, data: arr });
      },
      error => {}
    );
  };
}

export function blankChatArray() {
  return dispatch => {
    dispatch({ type: FETCH_CHATS, payload: { data: [], count: 0 } });
  };
}

export function clearChats() {
  return dispatch => {
    dispatch({ type: FETCH_CHATS, payload: {} });
  };
}

export function addChatThread(session, resource, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chatthread`;
  var body = {
    resource: resource
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateChatThread(session, chatthreadid, resource, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chatthread/${chatthreadid}`;

  return dispatch => {
    patchRequest(
      url,
      resource,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateChatThreadTime(
  session,
  chatthreadid,
  resource,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chatthread/${chatthreadid}`;

  return dispatch => {
    patchRequest(
      url,
      resource,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function addChatMessage(session, resource, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chat`;
  var body = {
    resource: resource.length === 1 ? resource[0] : resource
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateChatMessage(session, resource, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chat`;
  var body = {
    resource: resource
  };
  return dispatch => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateChat(session, chatid, resource, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chat/${chatid}`;

  return dispatch => {
    patchRequest(
      url,
      resource,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateChatUnread(session, chatthreadid, callback) {
  var filter = encodeURI(
    `(chatthreadid=${chatthreadid})AND(receiverid=${session.userid})AND(isread=0)`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chat?filter=(${filter})`;
  var body = {
    resource: [{ isread: 1, eventid: session.eventid }]
  };

  return dispatch => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function viewUserModal(value) {
  return dispatch => {
    dispatch({ type: VIEW_USER_MODAL, payload: value });
  };
}

export function attendeeListModal(value) {
  return dispatch => {
    dispatch({ type: ATTENDEE_LIST_MODAL, payload: value });
  };
}

export function timeoutList(value) {
  return dispatch => {
    dispatch({ type: TIMEOUT_LIST, payload: value });
  };
}

export function openMeetingModal(value) {
  return dispatch => {
    dispatch({ type: MEETING_MODAL, payload: value });
  };
}

export function uploadMedia(session, uploadFiles, callback) {
  // console.log('uploadFiles',uploadFiles);

  // let filecontent = uploadFiles.file.replace(/^data:image\/[a-z]+;base64,/, ''); // only for image type file
  let filecontent = uploadFiles.file.split(';base64,')[1]; // for all type of file
  // var filename = uploadFiles.name;
  // var filename = `eventify/chatmedia/${uploadFiles.name}`;
  var filename = `eventify/${session.eventid}/chatmedia/${uploadFiles.name}`;

  var mediaJson = {
    resource: [
      {
        name: filename,
        type: 'file',
        is_base64: true,
        content: filecontent
      }
    ]
  };
  return dispatch => {
    uploadEncodedFile(
      `${FILES_URL}?check_exist=false`,
      session,
      mediaJson,
      dispatch,
      response => {
        // console.log('response uploadMedia action: ', response);
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function showBackScreen(value) {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
}

export const fetchSuggestedUsers = (session, values = null, callback) => {
  let url = `${INSTANCE_URL}/api/v2/networkusers`;
  let body = {
    appuserid: session.userid,
    eventid: session.eventid,
    section: 'suggestions'
  };

  if (values) {
    body.section = 'filter_by_interests';
    body.interests = values.terms;
  }

  return dispatch => {
    dispatch({
      type: FETCH_SUGGESTED_USERS,
      payload: {}
    });
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('suggested users: ', response);
        let dispatchObj = {
          data: response.users,
          totalUnread: response.totalUnread
        };
        if (values) dispatchObj.selected = values.selected;

        dispatch({
          type: FETCH_SUGGESTED_USERS,
          payload: dispatchObj
        });
        callback({
          ...dispatchObj,
          success: 1
        });
      },
      error => {
        callback({ success: 0, data: error });
      }
    );
  };
};

export const openSuggestedFilterList = values => {
  return dispatch => {
    dispatch({ type: OPEN_SUGGESTED_FILTER, payload: values });
  };
};
